import CancelAppointmentConfirmationContainer from './routes/confirmation/CancelAppointmentConfirmationContainer.js';
import CancelAppointmentRoot from './routes/default/CancelAppointmentRoot.js';

const routeMap = {
    '': CancelAppointmentRoot,
    confirmation: CancelAppointmentConfirmationContainer
};

export { routeMap };
//# sourceMappingURL=route-map.js.map
